// Puts `value` back under a dotted path: ("units.USD", [..]) -> {units:{USD:[..]}}.
// The saved mapping reads its records at spec.recordPath of the WHOLE document,
// but "Fetch data" returns just the records, so the editor rebuilds the nesting.
export function wrapAtPath(path: string, value: unknown): unknown {
  if (!path) return value;
  return path
    .split('.')
    .reverse()
    .reduce<unknown>((inner, key) => ({ [key]: inner }), value);
}
